import { Cookies } from 'react-cookie';

import { AddTrapDataApiResponse } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getAddDataMultiTraps = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/traps/${slug}/add-trap-on-object/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as AddTrapDataApiResponse;
};
